import Base from './base';

export default class FulfillmentExternalRequest extends Base {
  resource = '/fulfillment_external_request';
}
